import { GamefieldView } from "./gamefield/GamefieldView";
import { DeckView } from "./deck/DeckView";
import { Sprite } from "@pixi/sprite";
import { Point, Texture } from "@pixi/core";
import { ICanvasScaler } from "../../../../../canvas/ICanvasScaler";
import { FederatedPointerEvent } from "@pixi/events";
import { IDestroyOptions } from "@pixi/display";
import { GameViewController } from "../../controllers/GameViewController";
import { BaseFigureView } from "./figures/BaseFigureView";
import { AudioManager } from "../../../../audio/AudioManager";
import { AudioNames } from "../../../../audio/AudioNames";

export class InputHandler extends Sprite {
    private movedFigure: BaseFigureView;
    private dragging: boolean;

    private readonly offset: number = 100;

    public constructor(
        private readonly gameViewController: GameViewController,
        private readonly deckView: DeckView,
        private readonly gamefieldView: GamefieldView,
        private readonly canvasScaler: ICanvasScaler,
        private readonly audioManager: AudioManager
    ) {
        super(Texture.EMPTY);
        const { width, height } = this.canvasScaler.getSize();
        this.width = this.canvasScaler.browserWidth / (width / this.canvasScaler.referenceWidth);
        this.height = this.canvasScaler.browserHeight / (height / this.canvasScaler.referenceHeight);
        this.eventMode = "static";
        this.visible = false;
        this.dragging = false;
        this.on("pointermove", this.onMove, this);
        this.on("pointerup", this.onPointerUp, this);
        this.on("pointerupoutside", this.onPointerUp, this);
        this.deckView.onStartMoveFigure.add(this.setMovedFigure, this);
    }

    private setMovedFigure(figure: BaseFigureView): void {
        this.audioManager.play(AudioNames.SelectFigure);
        this.visible = true;
        this.movedFigure = figure;
        this.dragging = true;
    }

    private onMove(event: FederatedPointerEvent): void {
        if (this.movedFigure == null && !this.dragging) {
            return;
        }
        const newPosition = this.movedFigure.position.clone();
        newPosition.x += 53;
        newPosition.y += 53;
        this.gamefieldView.getNearestCellIndex(this.deckView.toGlobal(newPosition));
        this.setFigurePosition(event.getLocalPosition(this.deckView));
    }

    private setFigurePosition(position: Point): void {
        this.movedFigure.position = position;
        this.movedFigure.y -= this.movedFigure.height + this.offset;
        this.movedFigure.x -= this.movedFigure.width * 0.5;
    }

    private onPointerUp(event: FederatedPointerEvent): void {
        this.dragging = false;
        this.visible = false;
        const newPosition = this.movedFigure.position.clone();
        newPosition.x += 53;
        newPosition.y += 53;
        const cellIndex = this.gamefieldView.getNearestCellIndex(this.deckView.toGlobal(newPosition));
        if (this.gamefieldView.isPlayAnimations) {
            this.deckView.revertMovedFigure();
            return;
        }
        const result = this.gameViewController.placeFigure(cellIndex);
        if (result) {
            this.audioManager.play(AudioNames.PlaceFigure);
        }
    }

    public override destroy(options?: IDestroyOptions | boolean): void {
        this.off("pointermove", this.onMove, this);
        this.off("pointerup", this.onPointerUp, this);
        this.off("pointerupoutside", this.onPointerUp, this);
        this.deckView.onStartMoveFigure.remove(this.setMovedFigure, this);
        super.destroy(options);
    }
}